import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, HostListener, Input, OnInit, Output } from '@angular/core';

import { Nullable } from '@frontend/sports/common/core/utils/extended-types';
import { Odds } from '@frontend/sports/odds/feature';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';

@Component({
    selector: 'bs-digital-linear-result-model-header',
    templateUrl: './linear-result-model-header.component.html',
    styleUrls: ['./linear-result-model-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LinearResultModelHeaderComponent implements OnInit {
    @Input() title: string;
    @Input() subtitle: string;
    @Input() odds?: Odds;
    @Input() boostedOdds?: Odds;
    @Input() oddsDisplayFormat?: OddsDisplayFormat;
    @Input() expand: boolean;
    @Input() isEpcotEnabled = true;

    @Output() expandToggled = new EventEmitter<boolean>();

    @HostListener('click', ['$event']) onClick($event: Nullable<Event>): void {
        this.toggleExpand($event);
    }

    @HostBinding('class.expanded') expanded = false;
    separator: string;

    ngOnInit(): void {
        this.expanded = this.expand;
        this.separator = this.isEpcotEnabled ? '\u2022' : ' - ';
    }

    toggleExpand($event?: Nullable<Event>): void {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }

        this.expanded = !this.expanded;
        this.expandToggled.emit(this.expanded);
    }
}
